import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARSimpleReceiveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Voucher/VoucherSimple")
	}

	render() {
		return (
			<Activity 
				name="FinanceARReceive"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARReceive"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARSimpleReceiveActivity)
